import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_2 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}

import { computed, onMounted, ref, watch } from "vue"
import GgmsChip from "@/components/GgmsChip.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import { useTagStore } from "@/stores/tag"
import { useOriginStore } from "@/stores/origin"
import { useLandingPageGroupStore } from "@/stores/landing-page-group"
import { useLifecycleStageStore } from "@/stores/lifecycle-stage"
import { useContactRoleStore } from "@/stores/contact-role"
import { useSalesStatusStore } from "@/stores/sales-status"

interface Props {
    modelValue: any
    options: any[]
    display?: "comma" | "chip"
    label?: string
    optionLabel?: string
    optionValue?: string
    placeholder?: string
    isShowClear?: boolean
    classes?: string
    errorMessage?: string
    invalid?: boolean
    disabled?: boolean
    emptyMessage?: string
    maxSelectedLabels?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GgmsMultiSelect',
  props: {
    modelValue: {},
    options: {},
    display: { default: "comma" },
    label: {},
    optionLabel: {},
    optionValue: {},
    placeholder: { default: "Select Element" },
    isShowClear: { type: Boolean },
    classes: {},
    errorMessage: {},
    invalid: { type: Boolean },
    disabled: { type: Boolean },
    emptyMessage: {},
    maxSelectedLabels: { default: 3 }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const tagStore = useTagStore()
const originStore = useOriginStore()
const landingPageGroupsStore = useLandingPageGroupStore()
const lifecycleStageStore = useLifecycleStageStore()
const contactRoleStore = useContactRoleStore()
const salesStatusStore = useSalesStatusStore()

const props = __props

const emit = __emit

const localModelValue = computed({
    get: () => props.modelValue,
    set: (value) => emit("update:modelValue", value),
})

const localErrorMessage = ref(props.errorMessage)
const localInvalid = ref(props.invalid)
const errorStyle = computed(() => (localInvalid.value ? "error-style" : ""))

const isChipDisplay = computed(() => props.display === "chip")
const isAllSelected = computed(() => localModelValue.value?.length === props.options?.length)
const selectedText = computed(() => (isAllSelected.value ? "Deselect All" : "Select All"))
const localDisabled = computed(() => props.disabled || !props.options?.length)

const cachedTags = computed(() => tagStore.cachedTags)
const cachedOrigins = computed(() => originStore.cachedOrigins)
const cachedGroups = computed(() => landingPageGroupsStore.cachedGroups)
const cachedLifecycleStages = computed(() => lifecycleStageStore.cachedLifecycleStages)
const cachedContactRoles = computed(() => contactRoleStore.cachedRoles)
const cachedSalesStatuses = computed(() => salesStatusStore.cachedSalesStatuses)

function disableValidationError() {
    localInvalid.value = false
    localErrorMessage.value = ""
}

function removeChip(id: any) {
    const index = localModelValue.value.findIndex((x: any) => x === id)
    localModelValue.value.splice(index, 1)
}

function toggleAll() {
    localModelValue.value = isAllSelected.value ? [] : props.options
}

function checkIfElementSelected(option: any) {
    return option.checked
}

onMounted(() => {
    disableValidationError()
})

watch(
    () => props.errorMessage,
    (value) => {
        localErrorMessage.value = value
    }
)

return (_ctx: any,_cache: any) => {
  const _component_MultiSelect = _resolveComponent("MultiSelect")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes)
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_MultiSelect, {
      modelValue: localModelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
      options: _ctx.options,
      display: _ctx.display,
      showClear: _ctx.isShowClear,
      optionLabel: _ctx.optionLabel,
      optionValue: _ctx.optionValue,
      placeholder: _ctx.placeholder,
      maxSelectedLabels: _ctx.maxSelectedLabels,
      class: _normalizeClass([errorStyle.value, _ctx.classes]),
      disabled: _ctx.disabled,
      emptyMessage: _ctx.emptyMessage,
      showToggleAll: false,
      onFocus: disableValidationError
    }, _createSlots({
      header: _withCtx(() => [
        _createVNode(GgmsCheckBox, {
          checked: isAllSelected.value,
          disabled: localDisabled.value,
          label: selectedText.value,
          class: "py-2 px-4",
          onClick: toggleAll
        }, null, 8, ["checked", "disabled", "label"])
      ]),
      itemcheckboxicon: _withCtx((slotProps) => [
        _createVNode(GgmsCheckBox, {
          checked: checkIfElementSelected(slotProps)
        }, null, 8, ["checked"])
      ]),
      _: 2
    }, [
      (isChipDisplay.value)
        ? {
            name: "value",
            fn: _withCtx((slotProps) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.value, (id) => {
                return (_openBlock(), _createBlock(GgmsChip, {
                  key: id,
                  bgColor: 
                        cachedTags.value[id]?.backgroundColor ??
                        cachedOrigins.value[id]?.backgroundColor ??
                        cachedGroups.value[id]?.backgroundColor ??
                        cachedLifecycleStages.value[id]?.backgroundColor ??
                        cachedContactRoles.value[id]?.backgroundColor ??
                        cachedSalesStatuses.value[id]?.backgroundColor
                    ,
                  textColor: 
                        cachedTags.value[id]?.foregroundColor ??
                        cachedOrigins.value[id]?.foregroundColor ??
                        cachedGroups.value[id]?.foregroundColor ??
                        cachedLifecycleStages.value[id]?.foregroundColor ??
                        cachedContactRoles.value[id]?.foregroundColor ??
                        cachedSalesStatuses.value[id]?.foregroundColor
                    ,
                  class: "mr-2",
                  onOnRemove: ($event: any) => (removeChip(id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cachedTags.value[id]?.displayName ??
                        cachedOrigins.value[id]?.displayName ??
                        cachedGroups.value[id]?.displayName ??
                        cachedLifecycleStages.value[id]?.displayName ??
                        cachedContactRoles.value[id]?.displayName ??
                        cachedSalesStatuses.value[id]?.displayName), 1)
                  ]),
                  _: 2
                }, 1032, ["bgColor", "textColor", "onOnRemove"]))
              }), 128))
            ]),
            key: "0"
          }
        : undefined,
      (isChipDisplay.value)
        ? {
            name: "option",
            fn: _withCtx((slotProps) => [
              _createVNode(GgmsChip, {
                bgColor: slotProps.option.backgroundColor,
                textColor: slotProps.option.foregroundColor,
                isRemovable: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(slotProps.option.displayName), 1)
                ]),
                _: 2
              }, 1032, ["bgColor", "textColor"])
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["modelValue", "options", "display", "showClear", "optionLabel", "optionValue", "placeholder", "maxSelectedLabels", "class", "disabled", "emptyMessage"]),
    (localErrorMessage.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(localErrorMessage.value), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})